import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["poster", "player"]

  play() {
    this.posterTarget.hidden = true
    this.playerTarget.hidden = false

    const playback = this.playerTarget.play()
    if (playback?.catch) playback.catch(() => {})
  }
}
